import axios from 'axios';

// 创建 axios 实例
const API = axios.create({
  // baseURL: 'http://192.168.195.189:18000/api',
  baseURL: 'api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器
API.interceptors.request.use(
  (config) => {
    // 可以在这里添加认证令牌等
    // const token = localStorage.getItem('token');
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`;
    // }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
API.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // 统一错误处理
    console.error('API 请求错误:', error);
    return Promise.reject(error);
  }
);

// API 端点
export const endpoints = {
  // 订阅相关
  subscriptions: {
    getCount: () => API.get('/subscriptions/count'),
    create: (data) => API.post('/subscriptions', data),
  },
  
  // 问题相关
  questions: {
    create: (data) => API.post('/questions', data),
  },
  
  // 其他 API 端点可以在这里添加
};

export default API; 